import AreaTypeIndustrial from "@keita/lanepatrol-sdk/assets/attributes/AreaTypeIndustrial.png";
import AreaTypeInnerUrban from "@keita/lanepatrol-sdk/assets/attributes/AreaTypeInnerUrban.png";
import AreaTypeOtherUrban from "@keita/lanepatrol-sdk/assets/attributes/AreaTypeOtherUrban.png";
import AreaTypeRural from "@keita/lanepatrol-sdk/assets/attributes/AreaTypeRural.png";
import FacilityTypeSidewalk from "@keita/lanepatrol-sdk/assets/attributes/FacilityTypeSidewalk.png";
import FacilityTypeMultiUsePath from "@keita/lanepatrol-sdk/assets/attributes/FacilityTypeMultiUsePath.png";
import FacilityTypeOffRoadBicyclePath from "@keita/lanepatrol-sdk/assets/attributes/FacilityTypeOffRoadBicyclePath.png";
import FacilityTypeOnRoadBicycleLane from "@keita/lanepatrol-sdk/assets/attributes/FacilityTypeOnRoadBicycleLane.png";
import FacilityTypeRoadShoulder from "@keita/lanepatrol-sdk/assets/attributes/FacilityTypeRoadShoulder.png";
import FacilityTypeMixedTrafficRoadLane from "@keita/lanepatrol-sdk/assets/attributes/FacilityTypeMixedTrafficRoadLane.png";
import FacilityAccessAdequate from "@keita/lanepatrol-sdk/assets/attributes/FacilityAccessAdequate.png";
import FacilityAccessInadequate from "@keita/lanepatrol-sdk/assets/attributes/FacilityAccessInadequate.png";
import LooseOrSlipperySurfacePresent from "@keita/lanepatrol-sdk/assets/attributes/LooseOrSlipperySurfacePresent.png";
import LooseOrSlipperySurfaceNotPresent from "@keita/lanepatrol-sdk/assets/attributes/LooseOrSlipperySurfaceNotPresent.png";
import TramOrTrainRailsPresent from "@keita/lanepatrol-sdk/assets/attributes/TramOrTrainRailsPresent.png";
import TramOrTrainRailsNotPresent from "@keita/lanepatrol-sdk/assets/attributes/TramOrTrainRailsNotPresent.png";
import MajorSurfaceDeformationOrDrainOpeningPresent from "@keita/lanepatrol-sdk/assets/attributes/MajorSurfaceDeformationOrDrainOpeningPresent.png";
import MajorSurfaceDeformationOrDrainOpeningNotPresent from "@keita/lanepatrol-sdk/assets/attributes/MajorSurfaceDeformationOrDrainOpeningNotPresent.png";
import FixedObstacleOnFacilityPresent from "@keita/lanepatrol-sdk/assets/attributes/FixedObstacleOnFacilityPresent.png";
import FixedObstacleOnFacilityNotPresent from "@keita/lanepatrol-sdk/assets/attributes/FixedObstacleOnFacilityNotPresent.png";
import NonFixedObstacleOnFacilityPresent from "@keita/lanepatrol-sdk/assets/attributes/NonFixedObstacleOnFacilityPresent.png";
import NonFixedObstacleOnFacilityNotPresent from "@keita/lanepatrol-sdk/assets/attributes/NonFixedObstacleOnFacilityNotPresent.png";
import LineOfSightAdequate from "@keita/lanepatrol-sdk/assets/attributes/LineOfSightAdequate.png";
import LineOfSightInadequate from "@keita/lanepatrol-sdk/assets/attributes/LineOfSightInadequate.png";
import DelineationPresent from "@keita/lanepatrol-sdk/assets/attributes/DelineationPresent.png";
import DelineationNotPresent from "@keita/lanepatrol-sdk/assets/attributes/DelineationNotPresent.png";
import LightSegregationPresent from "@keita/lanepatrol-sdk/assets/attributes/LightSegregationPresent.png";
import LightSegregationNotPresent from "@keita/lanepatrol-sdk/assets/attributes/LightSegregationNotPresent.png";
import FacilityWidthPerDirectionNarrow from "@keita/lanepatrol-sdk/assets/attributes/FacilityWidthPerDirectionNarrow.png";
import FacilityWidthPerDirectionVeryNarrow from "@keita/lanepatrol-sdk/assets/attributes/FacilityWidthPerDirectionVeryNarrow.png";
import FacilityWidthPerDirectionWide from "@keita/lanepatrol-sdk/assets/attributes/FacilityWidthPerDirectionWide.png";
import FlowDirectionOneWay from "@keita/lanepatrol-sdk/assets/attributes/FlowDirectionOneWay.png";
import FlowDirectionTwoWay from "@keita/lanepatrol-sdk/assets/attributes/FlowDirectionTwoWay.png";
import WidthRestrictionPresent from "@keita/lanepatrol-sdk/assets/attributes/WidthRestrictionPresent.png";
import WidthRestrictionNotPresent from "@keita/lanepatrol-sdk/assets/attributes/WidthRestrictionNotPresent.png";
import AdjacentFeatures0to1mRoadLanePresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mRoadLanePresent.png";
import AdjacentFeatures0to1mRoadLaneNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mRoadLaneNotPresent.png";
import AdjacentFeatures0to1mVehicleParkingPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mVehicleParkingPresent.png";
import AdjacentFeatures0to1mVehicleParkingNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mVehicleParkingNotPresent.png";
import AdjacentFeatures0to1mSevereHazardPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mSevereHazardPresent.png";
import AdjacentFeatures0to1mSevereHazardNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mSevereHazardNotPresent.png";
import AdjacentFeatures0to1mObjectOrLevelChangePresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mObjectOrLevelChangePresent.png";
import AdjacentFeatures0to1mObjectOrLevelChangeNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mObjectOrLevelChangeNotPresent.png";
import AdjacentFeatures0to1mSidewalkPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mSidewalkPresent.png";
import AdjacentFeatures0to1mSidewalkNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures0to1mSidewalkNotPresent.png";
import AdjacentFeatures1to3mRoadLanePresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mRoadLanePresent.png";
import AdjacentFeatures1to3mRoadLaneNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mRoadLaneNotPresent.png";
import AdjacentFeatures1to3mVehicleParkingPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mVehicleParkingPresent.png";
import AdjacentFeatures1to3mVehicleParkingNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mVehicleParkingNotPresent.png";
import AdjacentFeatures1to3mSevereHazardPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mSevereHazardPresent.png";
import AdjacentFeatures1to3mSevereHazardNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mSevereHazardNotPresent.png";
import AdjacentFeatures1to3mObjectOrLevelChangePresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mObjectOrLevelChangePresent.png";
import AdjacentFeatures1to3mObjectOrLevelChangeNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mObjectOrLevelChangeNotPresent.png";
import AdjacentFeatures1to3mSidewalkPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mSidewalkPresent.png";
import AdjacentFeatures1to3mSidewalkNotPresent from "@keita/lanepatrol-sdk/assets/attributes/AdjacentFeatures1to3mSidewalkNotPresent.png";
import GradeLessThan5degrees from "@keita/lanepatrol-sdk/assets/attributes/GradeLessThan5degrees.png";
import GradeMoreThan5degrees from "@keita/lanepatrol-sdk/assets/attributes/GradeMoreThan5degrees.png";
import CurvatureSharpTurn from "@keita/lanepatrol-sdk/assets/attributes/CurvatureSharpTurn.png";
import CurvatureNoSharpTurn from "@keita/lanepatrol-sdk/assets/attributes/CurvatureNoSharpTurn.png";
import StreetLightingPresent from "@keita/lanepatrol-sdk/assets/attributes/StreetLightingPresent.png";
import StreetLightingNotPresent from "@keita/lanepatrol-sdk/assets/attributes/StreetLightingNotPresent.png";
import PedestrianCrossingPresent from "@keita/lanepatrol-sdk/assets/attributes/PedestrianCrossingPresent.png";
import PedestrianCrossingNotPresent from "@keita/lanepatrol-sdk/assets/attributes/PedestrianCrossingNotPresent.png";
import IntersectionBicycleFacilityPresent from "@keita/lanepatrol-sdk/assets/attributes/IntersectionBicycleFacilityPresent.png";
import IntersectionBicycleFacilityNotPresent from "@keita/lanepatrol-sdk/assets/attributes/IntersectionBicycleFacilityNotPresent.png";
import IntersectionApproachShared from "@keita/lanepatrol-sdk/assets/attributes/IntersectionApproachShared.png";
import IntersectionApproachSeparateOrNA from "@keita/lanepatrol-sdk/assets/attributes/IntersectionApproachSeparateOrNA.png";
import IntersectionOrRoadCrossingPresent from "@keita/lanepatrol-sdk/assets/attributes/IntersectionOrRoadCrossingPresent.png";
import IntersectionOrRoadCrossingNotPresent from "@keita/lanepatrol-sdk/assets/attributes/IntersectionOrRoadCrossingNotPresent.png";
import CrossingFacilityPresent from "@keita/lanepatrol-sdk/assets/attributes/CrossingFacilityPresent.png";
import CrossingFacilityNotPresent from "@keita/lanepatrol-sdk/assets/attributes/CrossingFacilityNotPresent.png";
import NumberOfLanesAdjacentRoadOnePerDirection from "@keita/lanepatrol-sdk/assets/attributes/NumberOfLanesAdjacentRoadOnePerDirection.png";
import NumberOfLanesAdjacentRoadMoreThanOnePerDirection from "@keita/lanepatrol-sdk/assets/attributes/NumberOfLanesAdjacentRoadMoreThanOnePerDirection.png";
import NumberOfLanesIntersectingRoadOnePerDirection from "@keita/lanepatrol-sdk/assets/attributes/NumberOfLanesIntersectingRoadOnePerDirection.png";
import NumberOfLanesIntersectingRoadMoreThanOnePerDirection from "@keita/lanepatrol-sdk/assets/attributes/NumberOfLanesIntersectingRoadMoreThanOnePerDirection.png";
import PropertyAccessPresent from "@keita/lanepatrol-sdk/assets/attributes/PropertyAccessPresent.png";
import PropertyAccessNotPresent from "@keita/lanepatrol-sdk/assets/attributes/PropertyAccessNotPresent.png";
import PeakPedestrianFlowAlongOrAcrossFacilityNone from "@keita/lanepatrol-sdk/assets/attributes/PeakPedestrianFlowAlongOrAcrossFacilityNone.png";
import PeakPedestrianFlowAlongOrAcrossFacilityLow from "@keita/lanepatrol-sdk/assets/attributes/PeakPedestrianFlowAlongOrAcrossFacilityLow.png";
import PeakPedestrianFlowAlongOrAcrossFacilityMediumToHigh from "@keita/lanepatrol-sdk/assets/attributes/PeakPedestrianFlowAlongOrAcrossFacilityMediumToHigh.png";
import PeakBicycleAndLVTrafficFlowLow from "@keita/lanepatrol-sdk/assets/attributes/PeakBicycleAndLVTrafficFlowLow.png";
import PeakBicycleAndLVTrafficFlowMediumToHigh from "@keita/lanepatrol-sdk/assets/attributes/PeakBicycleAndLVTrafficFlowMediumToHigh.png";
import ObservedProportionOfCargoBikesAndMopedsLowToModerate from "@keita/lanepatrol-sdk/assets/attributes/ObservedProportionOfCargoBikesAndMopedsLowToModerate.png";
import ObservedProportionOfCargoBikesAndMopedsModerateToHigh from "@keita/lanepatrol-sdk/assets/attributes/ObservedProportionOfCargoBikesAndMopedsModerateToHigh.png";
import BicycleAndLVSpeedAverageLessThan20kmh from "@keita/lanepatrol-sdk/assets/attributes/BicycleAndLVSpeedAverageLessThan20kmh.png";
import BicycleAndLVSpeedAverageMoreThan20kmh from "@keita/lanepatrol-sdk/assets/attributes/BicycleAndLVSpeedAverageMoreThan20kmh.png";
import BicycleAndLVSpeedDifferentialLessThan10kmh from "@keita/lanepatrol-sdk/assets/attributes/BicycleAndLVSpeedDifferentialLessThan10kmh.png";
import BicycleAndLVSpeedDifferentialMoreThan10kmh from "@keita/lanepatrol-sdk/assets/attributes/BicycleAndLVSpeedDifferentialMoreThan10kmh.png";
import HeavyVehicleFlowLowOrRestrictedAccess from "@keita/lanepatrol-sdk/assets/attributes/HeavyVehicleFlowLowOrRestrictedAccess.png";
import HeavyVehicleFlowMediumToHigh from "@keita/lanepatrol-sdk/assets/attributes/HeavyVehicleFlowMediumToHigh.png";
import RoadAADT from "@keita/lanepatrol-sdk/assets/attributes/RoadAADT.png";
import RoadOperatingSpeed from "@keita/lanepatrol-sdk/assets/attributes/RoadOperatingSpeed.png";
import RoadSpeedLimit from "@keita/lanepatrol-sdk/assets/attributes/RoadSpeedLimit.png";
import {
  CraAttributeName,
  SpeedDifferentialType,
  AreaType,
  BicycleAndLVFlowType,
  CurvatureType,
  AdequateType,
  FacilityType,
  FacilityWidth,
  FlowDirectionType,
  GradeType,
  HeavyVehicleFlowType,
  IntersectionApproachType,
  NumberOfLanesType,
  PedestrianFlowType,
  PresenceType,
  ProportionOfCargoBikesAndMopedsType,
  SpeedAverageType,
} from "@keita/lanepatrol-sdk";

export const attributeImageMap: Record<CraAttributeName, any> = {
  [CraAttributeName.FacilityType]: {
    [FacilityType.Sidewalk]: FacilityTypeSidewalk,
    [FacilityType.MultiUsePath]: FacilityTypeMultiUsePath,
    [FacilityType.OffRoadBicyclePath]: FacilityTypeOffRoadBicyclePath,
    [FacilityType.OnRoadBicycleLane]: FacilityTypeOnRoadBicycleLane,
    [FacilityType.RoadShoulder]: FacilityTypeRoadShoulder,
    [FacilityType.MixedTrafficRoadLane]: FacilityTypeMixedTrafficRoadLane,
  },
  [CraAttributeName.FacilityAccess]: {
    [AdequateType.Adequate]: FacilityAccessAdequate,
    [AdequateType.Inadequate]: FacilityAccessInadequate,
  },
  [CraAttributeName.LooseOrSlipperySurface]: {
    [PresenceType.Present]: LooseOrSlipperySurfacePresent,
    [PresenceType.NotPresent]: LooseOrSlipperySurfaceNotPresent,
  },
  [CraAttributeName.TramOrTrainRails]: {
    [PresenceType.Present]: TramOrTrainRailsPresent,
    [PresenceType.NotPresent]: TramOrTrainRailsNotPresent,
  },
  [CraAttributeName.MajorSurfaceDeformationOrDrainOpening]: {
    [PresenceType.Present]: MajorSurfaceDeformationOrDrainOpeningPresent,
    [PresenceType.NotPresent]: MajorSurfaceDeformationOrDrainOpeningNotPresent,
  },
  [CraAttributeName.FixedObstacleOnFacility]: {
    [PresenceType.Present]: FixedObstacleOnFacilityPresent,
    [PresenceType.NotPresent]: FixedObstacleOnFacilityNotPresent,
  },
  [CraAttributeName.NonFixedObstacleOnFacility]: {
    [PresenceType.Present]: NonFixedObstacleOnFacilityPresent,
    [PresenceType.NotPresent]: NonFixedObstacleOnFacilityNotPresent,
  },
  [CraAttributeName.LineOfSight]: {
    [AdequateType.Adequate]: LineOfSightAdequate,
    [AdequateType.Inadequate]: LineOfSightInadequate,
  },
  [CraAttributeName.Delineation]: {
    [PresenceType.Present]: DelineationPresent,
    [PresenceType.NotPresent]: DelineationNotPresent,
  },
  [CraAttributeName.LightSegregation]: {
    [PresenceType.Present]: LightSegregationPresent,
    [PresenceType.NotPresent]: LightSegregationNotPresent,
  },
  [CraAttributeName.FacilityWidthPerDirection]: {
    [FacilityWidth.VeryNarrow]: FacilityWidthPerDirectionVeryNarrow,
    [FacilityWidth.Narrow]: FacilityWidthPerDirectionNarrow,
    [FacilityWidth.Wide]: FacilityWidthPerDirectionWide,
  },
  [CraAttributeName.FlowDirection]: {
    [FlowDirectionType.OneWay]: FlowDirectionOneWay,
    [FlowDirectionType.TwoWay]: FlowDirectionTwoWay,
  },
  [CraAttributeName.WidthRestriction]: {
    [PresenceType.Present]: WidthRestrictionPresent,
    [PresenceType.NotPresent]: WidthRestrictionNotPresent,
  },
  [CraAttributeName.Grade]: {
    [GradeType.LessThan5degrees]: GradeLessThan5degrees,
    [GradeType.MoreThan5degrees]: GradeMoreThan5degrees,
  },
  [CraAttributeName.Curvature]: {
    [CurvatureType.SharpTurn]: CurvatureSharpTurn,
    [CurvatureType.NoSharpTurn]: CurvatureNoSharpTurn,
  },
  [CraAttributeName.StreetLighting]: {
    [PresenceType.Present]: StreetLightingPresent,
    [PresenceType.NotPresent]: StreetLightingNotPresent,
  },
  [CraAttributeName.PedestrianCrossing]: {
    [PresenceType.Present]: PedestrianCrossingPresent,
    [PresenceType.NotPresent]: PedestrianCrossingNotPresent,
  },
  [CraAttributeName.IntersectionBicycleFacility]: {
    [PresenceType.Present]: IntersectionBicycleFacilityPresent,
    [PresenceType.NotPresent]: IntersectionBicycleFacilityNotPresent,
  },
  [CraAttributeName.IntersectionApproach]: {
    [IntersectionApproachType.Shared]: IntersectionApproachShared,
    [IntersectionApproachType.SeparateOrNA]: IntersectionApproachSeparateOrNA,
  },
  [CraAttributeName.IntersectionOrRoadCrossing]: {
    [PresenceType.Present]: IntersectionOrRoadCrossingPresent,
    [PresenceType.NotPresent]: IntersectionOrRoadCrossingNotPresent,
  },
  [CraAttributeName.CrossingFacility]: {
    [PresenceType.Present]: CrossingFacilityPresent,
    [PresenceType.NotPresent]: CrossingFacilityNotPresent,
  },
  [CraAttributeName.NumberOfLanesAdjacentRoad]: {
    [NumberOfLanesType.OnePerDirection]:
      NumberOfLanesAdjacentRoadOnePerDirection,
    [NumberOfLanesType.MoreThanOnePerDirection]:
      NumberOfLanesAdjacentRoadMoreThanOnePerDirection,
  },
  [CraAttributeName.NumberOfLanesIntersectingRoad]: {
    [NumberOfLanesType.OnePerDirection]:
      NumberOfLanesIntersectingRoadOnePerDirection,
    [NumberOfLanesType.MoreThanOnePerDirection]:
      NumberOfLanesIntersectingRoadMoreThanOnePerDirection,
  },
  [CraAttributeName.PropertyAccess]: {
    [PresenceType.Present]: PropertyAccessPresent,
    [PresenceType.NotPresent]: PropertyAccessNotPresent,
  },
  [CraAttributeName.PeakPedestrianFlowAlongOrAcrossFacility]: {
    [PedestrianFlowType.None]: PeakPedestrianFlowAlongOrAcrossFacilityNone,
    [PedestrianFlowType.Low]: PeakPedestrianFlowAlongOrAcrossFacilityLow,
    [PedestrianFlowType.MediumToHigh]:
      PeakPedestrianFlowAlongOrAcrossFacilityMediumToHigh,
  },
  [CraAttributeName.PeakBicycleAndLVTrafficFlow]: {
    [BicycleAndLVFlowType.Low]: PeakBicycleAndLVTrafficFlowLow,
    [BicycleAndLVFlowType.MediumToHigh]:
      PeakBicycleAndLVTrafficFlowMediumToHigh,
  },
  [CraAttributeName.ObservedProportionOfCargoBikesAndMopeds]: {
    [ProportionOfCargoBikesAndMopedsType.LowToModerate]:
      ObservedProportionOfCargoBikesAndMopedsLowToModerate,
    [ProportionOfCargoBikesAndMopedsType.ModerateToHigh]:
      ObservedProportionOfCargoBikesAndMopedsModerateToHigh,
  },
  [CraAttributeName.BicycleAndLVSpeedAverage]: {
    [SpeedAverageType.LessThan20kmh]: BicycleAndLVSpeedAverageLessThan20kmh,
    [SpeedAverageType.MoreThan20kmh]: BicycleAndLVSpeedAverageMoreThan20kmh,
  },
  [CraAttributeName.BicycleAndLVSpeedDifferential]: {
    [SpeedDifferentialType.LessThan10kmh]:
      BicycleAndLVSpeedDifferentialLessThan10kmh,
    [SpeedDifferentialType.MoreThan10kmh]:
      BicycleAndLVSpeedDifferentialMoreThan10kmh,
  },
  [CraAttributeName.RoadOperatingSpeed]: RoadOperatingSpeed,
  [CraAttributeName.RoadAADT]: RoadAADT,
  [CraAttributeName.HeavyVehicleFlow]: {
    [HeavyVehicleFlowType.LowOrRestrictedAccess]:
      HeavyVehicleFlowLowOrRestrictedAccess,
    [HeavyVehicleFlowType.MediumToHigh]: HeavyVehicleFlowMediumToHigh,
  },
  [CraAttributeName.RoadSpeedLimit]: RoadSpeedLimit,
  [CraAttributeName.AdjacentFeatures0to1mRoadLane]: {
    [PresenceType.Present]: AdjacentFeatures0to1mRoadLanePresent,
    [PresenceType.NotPresent]: AdjacentFeatures0to1mRoadLaneNotPresent,
  },
  [CraAttributeName.AdjacentFeatures0to1mVehicleParking]: {
    [PresenceType.Present]: AdjacentFeatures0to1mVehicleParkingPresent,
    [PresenceType.NotPresent]: AdjacentFeatures0to1mVehicleParkingNotPresent,
  },
  [CraAttributeName.AdjacentFeatures0to1mSevereHazard]: {
    [PresenceType.Present]: AdjacentFeatures0to1mSevereHazardPresent,
    [PresenceType.NotPresent]: AdjacentFeatures0to1mSevereHazardNotPresent,
  },
  [CraAttributeName.AdjacentFeatures0to1mObjectOrLevelChange]: {
    [PresenceType.Present]: AdjacentFeatures0to1mObjectOrLevelChangePresent,
    [PresenceType.NotPresent]:
      AdjacentFeatures0to1mObjectOrLevelChangeNotPresent,
  },
  [CraAttributeName.AdjacentFeatures0to1mSidewalk]: {
    [PresenceType.Present]: AdjacentFeatures0to1mSidewalkPresent,
    [PresenceType.NotPresent]: AdjacentFeatures0to1mSidewalkNotPresent,
  },
  [CraAttributeName.AdjacentFeatures1to3mRoadLane]: {
    [PresenceType.Present]: AdjacentFeatures1to3mRoadLanePresent,
    [PresenceType.NotPresent]: AdjacentFeatures1to3mRoadLaneNotPresent,
  },
  [CraAttributeName.AdjacentFeatures1to3mVehicleParking]: {
    [PresenceType.Present]: AdjacentFeatures1to3mVehicleParkingPresent,
    [PresenceType.NotPresent]: AdjacentFeatures1to3mVehicleParkingNotPresent,
  },
  [CraAttributeName.AdjacentFeatures1to3mSevereHazard]: {
    [PresenceType.Present]: AdjacentFeatures1to3mSevereHazardPresent,
    [PresenceType.NotPresent]: AdjacentFeatures1to3mSevereHazardNotPresent,
  },
  [CraAttributeName.AdjacentFeatures1to3mObjectOrLevelChange]: {
    [PresenceType.Present]: AdjacentFeatures1to3mObjectOrLevelChangePresent,
    [PresenceType.NotPresent]:
      AdjacentFeatures1to3mObjectOrLevelChangeNotPresent,
  },
  [CraAttributeName.AdjacentFeatures1to3mSidewalk]: {
    [PresenceType.Present]: AdjacentFeatures1to3mSidewalkPresent,
    [PresenceType.NotPresent]: AdjacentFeatures1to3mSidewalkNotPresent,
  },
  [CraAttributeName.AreaType]: {
    [AreaType.InnerUrban]: AreaTypeInnerUrban,
    [AreaType.OtherUrban]: AreaTypeOtherUrban,
    [AreaType.Rural]: AreaTypeRural,
    [AreaType.Industrial]: AreaTypeIndustrial,
  },
  [CraAttributeName.Comment]: undefined,
};
